class CustomNavbar extends HTMLElement {
    connectedCallback() {
        this.attachShadow({ mode: 'open' });
        this.shadowRoot.innerHTML = `
            <style>
                :host {
                    display: block;
                    position: sticky;
                    top: 0;
                    z-index: 50;
                    background-color: rgba(15, 23, 42, 0.9);
                    backdrop-filter: blur(8px);
                }
                nav {
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    padding: 1rem 2rem;
                    max-width: 1200px;
                    margin: 0 auto;
                }
                .logo {
                    height: 40px;
                }
                .nav-links {
                    display: flex;
                    gap: 1.5rem;
                }
                .nav-link {
                    color: white;
                    text-decoration: none;
                    font-weight: 500;
                    transition: color 0.3s;
                }
                .nav-link:hover {
                    color: #f8e8e8;
                }
                .book-btn {
                    background-color: #981010;
                    color: white;
                    padding: 0.5rem 1rem;
                    border-radius: 0.375rem;
                    font-weight: 500;
                    transition: background-color 0.3s;
                }
                .book-btn:hover {
                    background-color: #720c0c;
                }
                .mobile-menu-btn {
                    display: none;
                    background: none;
                    border: none;
                    color: white;
                    cursor: pointer;
                }
                @media (max-width: 768px) {
                    .nav-links {
                        display: none;
                    }
                    .mobile-menu-btn {
                        display: block;
                    }
                }
            </style>
            <nav>
                <a href="/" class="flex items-center">
                    <img src="https://huggingface.co/spaces/TheWizard42/cleanspot-jordan-station-sparkle/resolve/main/images/opulence%20logo%20with%20Text%201.png" alt="Opulence One Logo" class="logo">
</a>
                <div class="nav-links">
                    <a href="/" class="nav-link">Home</a>
                    <a href="/pages/about" class="nav-link">About Us</a>
                    <a href="/pages/services" class="nav-link">Services</a>
                    <a href="/pages/how-it-works" class="nav-link">How It Works</a>
                    <a href="/#booking-section" class="book-btn">Request Quote</a>
</div>
                <button class="mobile-menu-btn">
                    <i data-feather="menu"></i>
                </button>
            </nav>
        `;
    }
}
customElements.define('custom-navbar', CustomNavbar);